(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.video-gallery .video-popup').forEach(function (modal) {
      var video = modal.querySelector('video');
      if (!video) return;

      // Stop & reset video when modal is hidden
      modal.addEventListener('hide.bs.modal', function () {
        video.pause();
        video.currentTime = 0;
      });

      // Play video when modal is shown
      modal.addEventListener('show.bs.modal', function () {
        video.play();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
